module.exports = __webpack_public_path__ + "media/images/icon_x-dc1525d2afc9e52ee24e8cafef4a8a8c.svg";